import React from 'react';
import Select from 'react-select';

const styles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: 'var(--control-h, 38px)',
    height: 'var(--control-h, 38px)',
    borderColor: state.isFocused ? '#3b82f6' : '#cbd5e1',
    boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
    '&:hover': { borderColor: state.isFocused ? '#3b82f6' : '#cbd5e1' },
    fontSize: '0.875rem',
    backgroundColor: state.isDisabled ? '#f1f5f9' : provided.backgroundColor,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
    height: 'var(--control-h, 38px)',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: 'var(--control-h, 38px)',
  }),
  input: (provided) => ({ ...provided, margin: '0px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (provided) => ({ ...provided, fontSize: '0.875rem', zIndex: 30 }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  placeholder: (provided) => ({ ...provided, color: '#94a3b8' }),
};

const SearchableSelect = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select…',
  isClearable = false,
  isSearchable = true,
  isDisabled = false,
  includeAllOption = false,
  allLabel = 'All',
  allValue = 'all',
  inputId,
}) => {
  const normalized = options.map((o) =>
    typeof o === 'string' ? { value: o, label: o } : o
  );
  const list = includeAllOption
    ? [{ value: allValue, label: allLabel }, ...normalized]
    : normalized;

  return (
    <Select
      inputId={inputId}
      options={list}
      value={list.find((o) => String(o.value) === String(value)) || null}
      onChange={(option) => onChange(option ? option.value : '')}
      placeholder={placeholder}
      isClearable={isClearable}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      styles={styles}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition='fixed'
      menuPlacement='auto'
      menuShouldScrollIntoView={false}
    />
  );
};

export default SearchableSelect;
